import { useRouter } from "next/router";
import { useSyncExternalStore } from "react";

import {
  isCommentsPreviewLocation,
  isCommentsPreviewQuery,
} from "src/utils/comments-preview";

function subscribe(callback: () => void) {
  window.addEventListener("popstate", callback);
  return () => window.removeEventListener("popstate", callback);
}

function getSnapshot(): boolean {
  return isCommentsPreviewLocation();
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * True when `?comments=test` is present in development.
 *
 * Uses `useSyncExternalStore` so SSR/hydration match (server always false); preview
 * activates immediately after hydration without a mismatch.
 */
export function useCommentsPreviewMode(): boolean {
  const router = useRouter();
  const locationPreview = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );

  if (locationPreview) {
    return true;
  }
  if (!router.isReady) {
    return false;
  }
  return isCommentsPreviewQuery(router.query);
}
